import { useMutation, useQueryClient } from '@tanstack/react-query';
import { importProducts, importSuppliers, importCustomers } from '@/api/importApi';

export function useImportProducts() {
  const mdQueryClient = useQueryClient();
  return useMutation({
    mutationFn: (mdFile: File) => importProducts(mdFile),
    onSuccess: () => {
      mdQueryClient.invalidateQueries({ queryKey: ['products'] });
    },
  });
}

export function useImportSuppliers() {
  const mdQueryClient = useQueryClient();
  return useMutation({
    mutationFn: (mdFile: File) => importSuppliers(mdFile),
    onSuccess: () => {
      mdQueryClient.invalidateQueries({ queryKey: ['suppliers'] });
    },
  });
}

export function useImportCustomers() {
  const mdQueryClient = useQueryClient();
  return useMutation({
    mutationFn: (mdFile: File) => importCustomers(mdFile),
    onSuccess: () => {
      mdQueryClient.invalidateQueries({ queryKey: ['customers'] });
    },
  });
}
